import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import { viewersApi } from 'api/viewUserApi';
import { useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import { ViewerForm, ViewerInfo } from 'models/viewers';
import * as React from 'react';
import style from './Modal.module.scss';

export interface AddEditFormViewersProps {
  isEvent: boolean;
  itemViewer: ViewerInfo | undefined;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  setViewerList: (value: ViewerInfo[]) => void;
}

export default function AddEditFormViewers({
  isEvent,
  itemViewer,
  isModalVisible,
  setIsModalVisible,
  setViewerList,
}: AddEditFormViewersProps) {
  const [form] = Form.useForm();
  const isDisable = useAppSelector(selectIsDisable);

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (values: ViewerForm) => {
    try {
      if (!isEvent) {
        await viewersApi.add(values);
        const res = await viewersApi.fetchViewers({ _limit: 5, _page: 0 });
        openNotificationWithIcon('success',"Create user successfully")
        setViewerList(res.data);
      } else {
        //   const plantEdit = {
        //     id: itemPlantInfo.id,
        //     code: formatCodeItemPlant(values.code),
        //     label: values.label,
        //     address: values.address,
        //     azimuth: values.azimuth === undefined ? 0 : Number(values.azimuth),
        //     elevation: values.elevation === undefined ? 0 : Number(values.elevation),
        //     installation_date:
        //       values.installation_date === undefined ? 0 : Number(values.installation_date),
        //     system_size: values.system_size === undefined ? 0 : Number(values.system_size),
        //     tilt: values.tilt === undefined ? 0 : Number(values.tilt),
        //     coordinantes:
        //       values.lat === undefined || values.long === undefined
        //         ? null
        //         : {
        //             lat: Number(values.lat),
        //             long: Number(values.long),
        //           },
        //   };
        //   await plantApi.update(plantEdit);
        //   await dispatch(sidebarActions.fetchSidebarList(userId));
      }
    } catch (error) {
      openNotificationWithIcon('error',"please check the data again!")
    }
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      visible={isModalVisible}
      footer={
        <div className={style.footer_modal}>
          <Button onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </Button>
          <Button disabled={isDisable} onClick={() => form.submit()} className={style.btn_submit}>
            Submit
          </Button>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={itemViewer}
        onFinish={(values) => handleOk(values)}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="first_name"
              label="First Name :"
              rules={[{ required: true, message: 'Please enter First Name' }]}
            >
              <Input placeholder="Please enter First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="last_name"
              label="Last Name :"
              rules={[{ required: true, message: 'Please enter Last Name' }]}
            >
              <Input placeholder="Please enter Last Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="email"
              label="Email :"
              rules={[
                { required: true, message: 'Please enter Email' },
                {
                  pattern:
                    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/,
                  message: ' this is not a valid email',
                },
              ]}
            >
              <Input placeholder="Please enter Email" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
